import { apiFetch } from './client';

export async function getMyTutorStudents() {
  return apiFetch('/me/tutor/students');
}

export async function getMyParentStudents() {
  return apiFetch('/me/parent/students');
}

export async function getMyStudentDashboard() {
  return apiFetch('/me/student/dashboard');
}

export async function getMyPracticeCurriculum() {
  return apiFetch('/me/student/full-curriculum');
}

export async function getMyWeeklyPracticePlan() {
  return apiFetch('/me/student/weekly-practice-plan');
}

export async function getStudentPracticeCurriculum(studentId) {
  return apiFetch(`/me/students/${studentId}/full-curriculum`);
}

export async function getStudentWeeklyPracticePlan(studentId) {
  return apiFetch(`/me/students/${studentId}/weekly-practice-plan`);
}

export async function getStudentWeeklyPracticePlanSummary(studentId) {
  return apiFetch(`/me/students/${studentId}/weekly-practice-plan`);
}

export async function createTutorLinkRequest(studentEmail) {
  return apiFetch('/me/tutor/link-requests', {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ student_email: studentEmail }),
  });
}

export async function getMyTutorLinkRequests() {
  return apiFetch('/me/tutor-link-requests');
}

export async function getMyGuardianRelationshipRequests() {
  return apiFetch('/me/guardian-relationship-requests');
}

export async function approveGuardianRelationshipRequest(cohortRequestId) {
  return apiFetch(`/me/guardian-relationship-requests/${cohortRequestId}/approve`, { method: 'POST' });
}

export async function acceptTutorLinkRequest(requestId) {
  return apiFetch(`/me/tutor-link-requests/${requestId}/accept`, { method: 'POST' });
}

export async function approveTutorLinkRequestAsGuardian(requestId) {
  return apiFetch(`/me/tutor-link-requests/${requestId}/guardian-approve`, { method: 'POST' });
}

export async function rejectTutorLinkRequest(requestId) {
  return apiFetch(`/me/tutor-link-requests/${requestId}/reject`, { method: 'POST' });
}
